import type { FC, ReactNode } from "react";

import { useBanners } from "@shared/components/Banners/useBanners";

import { style } from "./BannersShim.styles";

interface Props {
  children?: ReactNode;
}

const BannersShim: FC<Props> = ({ children }) => {
  const { bannersHeight } = useBanners();

  return <div css={style(bannersHeight)}>{children}</div>;
};

export { BannersShim };
